module.exports = __webpack_public_path__ + "static/media/VaccinVirus.960f1b2e.jpg";